/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Summary_Other_Present_3Inputs */



/**
* | output |
* | --- |
* | "putting a tool to work" |
*
* @param {Chat_Summary_Other_Present_3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_summary_other_present_3 = /** @type {((inputs?: Chat_Summary_Other_Present_3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Summary_Other_Present_3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("setze ein Tool ein")
	return /** @type {LocalizedString} */ ("putting a tool to work")
});